import type { ArtifactVersionDto } from '@inference.engine/api-client';
import { inferenceHttp } from '@/lib/api/http-client';

export const saveFocusGroupAsArtifact = async (
  focusGroupId: string,
  workspaceId: string,
): Promise<string> => {
  const response = await inferenceHttp.post({
    url: `/api/v1/focus-groups/${focusGroupId}/artifact`,
    query: { workspaceId },
  });

  const data = response.data as ArtifactVersionDto;
  if (!data.id) {
    throw new Error('Failed to save focus group as artifact');
  }
  return data.id;
};
